import { API_CONFIG } from '../config/api';
import { AuthenticatedApiService } from './authenticatedApiService';

export interface DashboardStatistics {
  totalUsers: number;
  totalTenants: number;
  totalSubscriptions: number;
  totalRoles: number;
  totalPermissions: number;
}

export interface DashboardStatisticsResponse {
  data: DashboardStatistics;
  succeeded: boolean;
  errorDescription: string | null;
  errorCode: number;
}

class DashboardApiService extends AuthenticatedApiService {
  /**
   * Get dashboard statistics
   */
  async getStatistics(): Promise<DashboardStatisticsResponse> {
    const url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DASHBOARD_STATISTICS}`;
    
    const response = await this.makeAuthenticatedCall(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  }

  /**
   * Initialize the service with tokens and refresh callback
   */
  initialize(tokens: any, onTokenRefresh: (tokens: any) => void): void {
    this.setTokens(tokens, onTokenRefresh);
  }
}

// Export singleton instance
export const dashboardService = new DashboardApiService();
